import React from "react"
import { cn } from "@/lib/utils/utils"

type LogoProps = {
  variant?: "color" | "white"
  className?: string
  width?: number
  height?: number
}

export function Logo({
  variant = "color",
  className,
  width = 100,
  height = 25,
}: LogoProps) {
  const src =
    variant === "color"
      ? "/icons/logo_color_horizontal.svg"
      : "/icons/logo_white_horizontal.svg"

  return (
    <div className={cn("relative", className)}>
      <img src={src} alt="Pandora's Way" width={width} height={height} />
    </div>
  )
}
